//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Dropdown from "~/components/form/Dropdown";

export default {
  components: {
    Dropdown,
  },
  props: {
    incomingFilters: {
      type: Object,
      require: true,
      default: () => {}
    }
  },
  data() {
    return {
      categories: {
        sorted: [],
        selected: ''
      }
    }
  },
  mounted() {
    this.sortType(this.incomingFilters.categories, 'categories');
  },
  methods: {
    sortType(data, type) {
      const result = [];
      const haveSelected = this.$route.query.hasOwnProperty('categories')
      const selectedId = this.$route.query.categories
      data.forEach(item => {
        const obj = {name: item.name ? item.name : item, id: item.id ? item.id : item}
        result.push(obj)
        if (haveSelected && Number(selectedId) === Number(obj.id)) {
           this.categories.selected = obj
        }
      })
      this.categories.sorted = result;
    }
  }
}
